import { render, staticRenderFns } from "./RatingNew.vue?vue&type=template&id=1370e9e0&scoped=true&lang=html"
import script from "./RatingNew.vue?vue&type=script&lang=js"
export * from "./RatingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370e9e0",
  null
  
)

export default component.exports